<template>
	<div class="drawer-container">
		<div class="general-title">
			<div class="title">Variant{{ numVariants !== 1 ? 's' : '' }} for {{ product.title }}</div>
			<div class="buttons-container buttons">
				<router-link :to="`/commerce/products/${ product.id }/edit`" class="good-bg">Update Product<span class="fa fa-pencil"></span></router-link>
			</div>
		</div>
		<div v-for="(price, variant) in product.variants" :key="`product-${ product.id }-variant-${ variant }`" class="input-container">
			<div class="input-title shrink add-border-right">${{ parseFloat(price).toFixed(2) }}</div>
			<div class="input-static-text">{{ variant }}</div>
		</div>
	</div>
</template>

<script>

import { DRAWERS } from '@/constants';

export default {

	props: [
		'product'
	],

	computed: {

		numVariants() {
			return Object.values(this.product.variants || []).length;
		},

	},

	methods: {

		close() {
			this.$root.$emit('close-drawer', DRAWERS.PRODUCT_VARIANTS);
		},

	},
};

</script>
